var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "light-bulb_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.792h6v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 11.085a1 1 0 10-1.414 1.414L11 14.206v6.586h2v-6.586l1.707-1.707a1 1 0 00-1.414-1.414L12 12.378l-1.293-1.293z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 16.077l.75-.6a6 6 0 10-7.498 0l.748.6v1.715a1 1 0 001 1h4a1 1 0 001-1v-1.715zm2 .96v.755a3 3 0 01-3 3h-4a3 3 0 01-3-3v-.755a8 8 0 1110 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNOSAxOC43OTJoNnYyYTIgMiAwIDAxLTIgMmgtMmEyIDIgMCAwMS0yLTJ2LTJ6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTAuNzA3IDExLjA4NWExIDEgMCAxMC0xLjQxNCAxLjQxNEwxMSAxNC4yMDZ2Ni41ODZoMnYtNi41ODZsMS43MDctMS43MDdhMSAxIDAgMDAtMS40MTQtMS40MTRMMTIgMTIuMzc4bC0xLjI5My0xLjI5M3oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUgMTYuMDc3bC43NS0uNmE2IDYgMCAxMC03LjQ5OCAwbC43NDguNnYxLjcxNWExIDEgMCAwMDEgMWg0YTEgMSAwIDAwMS0xdi0xLjcxNXptMiAuOTZ2Ljc1NWEzIDMgMCAwMS0zIDNoLTRhMyAzIDAgMDEtMy0zdi0uNzU1YTggOCAwIDExMTAgMHoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgLightBulb as ReactComponent };